module.exports = __webpack_public_path__ + "static/img/CareerOpportunitiesBg-p.c36119a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/CareerOpportunitiesBg-p.png
// module id = Fw2a
// module chunks = 1